// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ExternalSubscriptionRequestLogsController = function ($scope, $routeParams, ExternalSubscriptionRequestLogs) {
    $scope.before = $routeParams.before ? $routeParams.before : null;
    $scope.after = $routeParams.after ? $routeParams.after : null;
    $scope.maxCount = 100;
    $scope.subScope = { showFullUrl: false };

    $scope.loadLogs = function () {
        $scope.logs = [];
        $scope.maxId = null;
        $scope.loadNext();
    };

    $scope.loadNext = function () {
        ExternalSubscriptionRequestLogs.query({
            Id: $scope.id,
            ExternalSubscriptionId: $scope.externalSubscriptionId,
            ExternalSubscriptionType: $scope.externalSubscriptionType,
            ErrorCode: $scope.errorCode,
            Response: $scope.response,
            Before: $scope.before,
            After: $scope.after,
            MaxId: $scope.maxId,
            Entity: $scope.entity,
            MaxCount: $scope.maxCount
        }, function (data) {
            $scope.logs = $scope.logs.concat(data);
            if ($scope.logs.length > 0)
                $scope.maxId = $scope.logs[$scope.logs.length - 1].Id;
        });
    };
    
    ExternalSubscriptionRequestLogs.getEnums({
    }, function (data) {
        $scope.externalSubscriptionTypes = data.ExternalSubscriptionTypes;
        $scope.errorCodes = data.ErrorCodes;
        $scope.externalSubscriptionTypes.unshift("All subscription types");
        $scope.errorCodes.unshift("All error codes");
        $scope.externalSubscriptionType = $scope.externalSubscriptionTypes[0];
        $scope.errorCode = $scope.errorCodes[0];
    });

    $scope.loadLogs();
};
ExternalSubscriptionRequestLogsController.$inject = ['$scope', '$routeParams', 'ExternalSubscriptionRequestLogs'];
